module.exports = __webpack_public_path__ + "static/media/uk.5cc8e98f.svg";